import { type PermissionProjectPermissions } from "../../SettingsPermissions/types/permissions.types.ts"
import { invoicesHiddenForRole } from "../../../utils/invoices-visibility.ts"
import { canViewFinanceTab } from "./project-finance-visibility.ts"

export type ProjectSectionKeys =
  | "milestones"
  | "finance"
  | "invoices"
  | "tasks"
  | "commissions"
  | "files"
  | "messages"
  | "logs"

export const PROJECT_TAB_ORDER: ProjectSectionKeys[] = [
  "milestones",
  "finance",
  "invoices",
  "tasks",
  "commissions",
  "files",
  "messages",
  "logs"
]

export const getVisibleProjectTabs = (
  permissions: PermissionProjectPermissions | undefined,
  roleId?: number | null
): ProjectSectionKeys[] => {
  const visibility: Record<ProjectSectionKeys, boolean> = {
    milestones: !!permissions?.milestones?.project_milestone_view,
    finance: canViewFinanceTab(permissions),
    invoices:
      !!permissions?.invoices?.project_invoice_view &&
      !invoicesHiddenForRole(roleId),
    tasks: !!permissions?.checklists?.project_checklist_view,
    commissions: !!permissions?.commissions?.project_commission_view,
    files: !!permissions?.docs?.project_doc_view,
    // Messages has no permission code of its own — who may read a conversation
    // is decided by that conversation's own membership, and a second gate here
    // could only hide a room from somebody the server would let in. It still
    // follows the right that opens the project at all, so a caller who can
    // view nothing here sees no tabs, Messages included.
    messages: !!permissions?.projects?.project_view,
    logs: !!permissions?.features?.project_activity_log
  }

  return PROJECT_TAB_ORDER.filter((tab) => visibility[tab])
}
